<div class="crm-label-picker" [class.disabled]="disabled">
  <div class="selected-actions" *ngIf="selectedLabels?.length">
    <button
      type="button"
      class="remove-btn"
      *ngFor="let label of selectedLabels"
      (click)="removeLabel(label.id)"
      [disabled]="disabled"
      [ngStyle]="chipStyle(label)"
    >
      <span class="swatch" [style.background-color]="label.color"></span>
      {{ label.name }}
      <span class="archived" *ngIf="label.active === false">(Archived)</span>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
  </div>

  <button type="button" class="picker-toggle" [class.open]="open" (click)="toggleDropdown()" [disabled]="disabled">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" width="15" height="15"><path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3.24L3 3v6.59a2 2 0 0 0 .59 1.41l9.58 9.58a2 2 0 0 0 2.82 0l4.6-4.6a2 2 0 0 0 0-2.82z"/><line x1="7.5" y1="7.5" x2="7.51" y2="7.5"/></svg>
    <span>Select labels</span>
    <span class="count">{{ selectedIds.length }}/{{ maxSelection }}</span>
    <svg class="chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" width="13" height="13"><polyline points="6 9 12 15 18 9"/></svg>
  </button>

  <div class="dropdown" *ngIf="open">
    <div class="picker-search">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" width="13" height="13"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input type="text" placeholder="Search labels" [(ngModel)]="searchText" />
    </div>

    <div class="hint" *ngIf="atLimit">Maximum of {{ maxSelection }} labels reached.</div>
    <div class="hint" *ngIf="loading">Loading labels…</div>
    <div class="hint" *ngIf="!loading && !filteredActiveLabels.length">No active labels found.</div>

    <div class="option-list">
      <button
        type="button"
        class="option"
        *ngFor="let label of filteredActiveLabels"
        (click)="toggleLabel(label)"
        [class.selected]="isSelected(label.id)"
        [disabled]="!isSelected(label.id) && atLimit"
      >
        <span class="swatch" [style.background-color]="label.color"></span>
        <span class="name">{{ label.name }}</span>
        <svg *ngIf="isSelected(label.id)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg>
      </button>
    </div>
  </div>
</div>
